import React, { Component } from 'react'
import './donate.css'
import donatelogo from './donatelogo.webp'
import heart from './heart.jpg'
import pdfteam from './pdfteam.jpg'
    import pdflogo from './pdflog.png'
    import paypal from './paypal.gif'
import poi from './poi.png'

class Donate extends Component {
    state = {

    }


    render() {
        return (
            <React.Fragment>
                <div className="ddonate">
                    <div className="donateback">

                        <div className="textga container">
                            <div className="qw">
                                <p>
                                    <h3>
                                        To all readers around the world,
                                    </h3> <br />
                                    <span>PDF Drive</span> is something special. It is like a library or a public park. It is a place we can all go think, to learn, to <br />
                                    share our knowladge with others for no cost since 2014. <br /> <br />

                                    However our funds are becoming limited, we wish to keep <span>PDF Drive</span> triving for years to come, <span>to preserve free, <br />
                                        accessible knowladge to our users</span>  and even expand to be able to provide for those beyond the scope of the <br />
                                    interweb. <br /> <br />

                                    In this case, we are asking for your help. A donation of any size would help PDF Drive reach goals that will help <br />
                                    more than just its users. <br /> <br />

                                    As we wish to continue growing PDF Drive, we hope you accept our request. We appreciate you, regardless of your <br />
                                    situation to help, and will Continue providing current services as is. <br /> <br />

                                    Thank you for takin the time to read. We are grateful for your time and consideration. <br /> <br />


                                    Wishing you all the best, <br /> <br />
                                    The PDF Drive Team
                                </p>
                            </div>
                        </div>
                        <div className="paypal container">
                            <p className="using">Using Paypal:</p> <br />
                            <a href="https://www.paypal.com/donate?token=Ts467XX3d3APz1nL25nO1ZrrWg3_dBWGkc9D_OzMl2O5WLDcsrxDgtMWbWywoNS6qHSY9tZZwhp3Nyym">
                              <img className="pyp" src={paypal} alt="" /> <br />
                            </a>
                            <p className="ll">
                              <span className="btc">BTC:</span> 3JAm9LPEgmtNooHqo7ZaiErYvQ8RrB9G1i
                            </p>
                            <p className="ll">
                              <span className="btc">ETH:</span> 0x58CE350D3C3c39346860461808d7B9E2ED9034da
                            </p>
                            <p className="ll">
                              <span className="btc">LTC:</span> MMNu7mrgDoNdnrJ8JVHa3yQyjYgXF2UQqs
                            </p>
                            <p className="ll">
                              <span className="btc">LINK:</span> 0x58CE350D3C3c39346860461808d7B9E2ED9034da

                            </p>

                        </div>
                        <div className="donatesecondpart">
                            <div className="donateleft">
                                <span className="the">
                                    <p className="pdfteam">The PDF Drive Team</p>
                                    <i className="fa fa-heart"></i>
                                </span>
                                <img className="teamimg" src={pdfteam} alt="" />
                            </div>
                            <div className="donateright">
                                <h5 className="where">Where your donations goes?</h5> <br />
                                <p className="tech">Technology:</p>
                                <p className="techmatn">Servers, bandwidth, maintenance, development. PDF Drive is the <br />
                                    3,383th most visited website in the world, and it runs on a fraction <br />
                                    of what other top websites spend.</p> <br />
                                <p className="tech">
                                    People and Projectcs
                                </p>
                                <p className="techmatn">
                                    The other top websites have thousands of employees. We have 5 <br />
                                    staff to support a wide variety of projects, making your donation a <br />
                                    great investment in a highly-efficient not-for-profit organization.
                                </p>
                            </div>
                        </div>
                        <div className="dd">
                            <div className="donatefooter container">
                                <div className="donin">

                                    <img className="pdflog" src={pdflogo} alt="" />

                                    <div>
                                        <p>Company</p>
                                        <a href="https://www.pdfdrive.com/home/about">About</a><br />
                                        <a href="https://www.pdfdrive.com/app">Mobile App</a> <br />
                                        <a href="https://www.pdfdrive.com/home/terms">Terms & Privacy</a>
                                    </div>
                                    <div>
                                        <p>Social</p>
                                        <a href="https://twitter.com/pdfdrive">Twitter</a><br />
                                        <a href="https://www.facebook.com/pdfdrive">Facebook</a> <br />
                                        <span className="donher">
                                        <a href="https://www.pdfdrive.com/donate">Donate</a>
                                        <i className="fa fa-heart"></i>
                                        </span>
                                    </div>
                                    <div>
                                        <p>Help</p>
                                        <a href="https://www.pdfdrive.com/home/contact">Contact Us</a><br />
                                        <a href="https://www.pdfdrive.com/home/contact">Feedback</a> <br />
                                        <a href="https://www.pdfdrive.com/home/dmca">DMCA & Copyright</a>
                                    </div>

                                </div>
                            </div>
                        </div>


                    </div>
                </div>

            </React.Fragment>
        )
    }
}
export default Donate